import { useMemo } from "react";
import { Check, X } from "lucide-react";

const rules = [
  { key: "len", label: "8+ characters", test: (p) => p.length >= 8 },
  { key: "num", label: "Number", test: (p) => /\d/.test(p) },
  { key: "sym", label: "Symbol", test: (p) => /[^\w\s]/.test(p) },
  { key: "upp", label: "Uppercase", test: (p) => /[A-Z]/.test(p) },
];

export function scorePassword(p = "") {
  if (!p) return 0;
  let score = 0;
  rules.forEach((r) => { if (r.test(p)) score += 1; });
  if (p.length >= 12) score += 1;
  return Math.min(score, 5);
}

const LEVELS = [
  { label: "Very weak", color: "bg-rose-500", text: "text-rose-600" },
  { label: "Weak", color: "bg-orange-500", text: "text-orange-600" },
  { label: "Okay", color: "bg-amber-500", text: "text-amber-600" },
  { label: "Good", color: "bg-lime-500", text: "text-lime-600" },
  { label: "Strong", color: "bg-emerald-500", text: "text-emerald-600" },
  { label: "Excellent", color: "bg-emerald-600", text: "text-emerald-700" },
];

export default function PasswordStrength({ value = "" }) {
  const score = useMemo(() => scorePassword(value), [value]);
  const level = LEVELS[score];
  return (
    <div data-testid="password-strength" className="space-y-2">
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className={`h-1 flex-1 rounded-full transition-colors duration-200 ${i < score ? level.color : "bg-gray-200"}`} />
        ))}
      </div>
      {value && (
        <div className={`text-[11px] font-medium ${level.text}`} data-testid="password-strength-label">
          {level.label}
        </div>
      )}
      <div className="grid grid-cols-2 gap-1 pt-1">
        {rules.map((r) => {
          const ok = r.test(value);
          return (
            <div key={r.key} className={`flex items-center gap-1 text-[11px] ${ok ? "text-emerald-600" : "text-gray-400"}`}>
              {ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
              {r.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
